<template>
  <div class="improve">
    <div class="title">提分秘籍</div>
    <div class="content">
      <div class="video">
        <template v-if="videoList.length">
          <video-player
            style="
              width: 100%;
              height: 100%;
              overflow: hidden;
              margin: auto auto;
            "
            :video="currentNode"
            :key="videoKey"
          ></video-player>
        </template>
        <template v-else>
          <div class="no-video">暂无精讲视频</div>
        </template>
      </div>
      <div class="player-card">
        <div class="title">提分秘籍</div>

        <el-tree
          style="
            background-color: #404040;
            height: 91%;
            overflow-y: auto;
            overflow-x: hidden;
          "
          :data="videoList"
          :props="props"
          :highlight-current="false"
          @node-click="handleNodeClick"
        >
          <span
            slot-scope="{ node, data }"
            :style="{
              color:
                data.resId != null && data.resId === currentNode.resId
                  ? '#0096ff'
                  : !!data.playRecordsCount
                  ? '#90ff00'
                  : '#ffffff',
            }"
          >
            {{ data.title }} {{ data.speaker ? "(" + data.speaker + ")" : "" }}
          </span>
        </el-tree>
      </div>
    </div>

    <!-- 支付弹窗 -->
    <el-dialog
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      custom-class="pay-dialod-visible"
      @close="closeDialog"
    >
      <div class="count">
        <div v-if="!wxPay" class="zfb_box">
          <div>
            <!-- <img class="vip_card" src="../../assets/images/vip/vip.jpg" alt="" @click.stop="buyVip">
                <div class="has_active_price"><span>定价：</span>￥{{orderInfo.orderAmount ? orderInfo.orderAmount : 200}} <span class="lineation" style="display: block">成为会员享受更多优惠</span></div> -->
            <!-- <div class="pay_types">1.请选择套餐</div> -->
            <div class="pay_types">本提分秘籍</div>
            <div class="goodsList">
              <div
                v-for="(item, index) in goodsList"
                :class="['goodsItem', { active: goodsIndex == index }]"
                @click="chooseGoods(index)"
                :key="index"
              >
                <!-- {{ item.money }}元/{{ item.name }} -->
                {{ item.money }}元
              </div>
            </div>
            <!-- <div class="pay_types">2.请选择支付方式</div> -->
            <div class="pay_types">请选择支付方式</div>
            <div class="right_f">
              <div class="wx" @mouseenter="wxEnter" @mouseleave="wxLeave">
                <img
                  src="../../assets/images/main/wx.png"
                  alt=""
                  @click="weChatPayment"
                />
              </div>
              <div class="zfb" @click="alipayPayment">
                <img src="../../assets/images/main/zfb.png" alt="" />
              </div>
              <div class="balance">
                <div class="left">
                  <img src="@/assets/images/client/qianbao.png" alt="" />
                  <div class="msg">
                    <span>余额</span>
                    <span style="color: #ff0000">{{ price }}</span>
                    <span
                      style="font-size: 14px; color: #ff0000"
                      v-if="balanceShow"
                      >（不足支付）</span
                    >
                  </div>
                </div>
                <button class="right" v-if="balanceShow" @click="openWindows">
                  充值
                </button>
                <button class="right" v-else @click="balancePayment">
                  支付
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="wx_box">
          <h3>微信扫描二维码完成支付</h3>
          <div class="price">
            <span>实付金额：</span><span style="color: #e50001">￥</span>
            <span class="p_num_new">{{ orderInfo.orderAmount }}</span>
          </div>
          <div class="right">
            <div class="right_QrCode">
              <qrCode
                class="right_QrCode_img"
                v-if="payCodeUrl"
                :pay-code-url="payCodeUrl"
              >
              </qrCode>
            </div>
          </div>
          <p class="pOne">
            打开微信【扫一扫】扫描上方的二维码，按操作提示完成支付
          </p>
          <p class="pOne">请在2小时内完成操作，超时后需要重新开始购买</p>
        </div>
      </div>
    </el-dialog>

    <!-- 支付宝支付 -->
    <div v-if="!!html" v-html="html"></div>
  </div>
</template>
<script>
import videoPlayer from "@/components/video-player/video-improve.vue";
import qrCode from "@/components/qr-code/qr-code-for-wxpay";
export default {
  name: "improve",
  components: {
    videoPlayer,
    qrCode
  },
  data() {
    return {
      videoList: [],
      dialogVisible: false,
      wxPay: false,
      orderInfo: {},
      wxShow: false,
      price: 0,
      payCodeUrl: undefined,
      goodsList: [],
      goodsInfo: {},
      goodsIndex: 0,
      html: "",
      props: {
        label: "title",
        children: "sources"
      },
      currentNode: {},
      //重新渲染试图
      videoKey: 0
    };
  },
  computed: {
    balanceShow() {
      let pic = this.orderInfo.orderAmount ? this.orderInfo.orderAmount : 200;
      if (pic > this.price) {
        return true; // 显示充值
      } else {
        return false;
      }
    }
  },
  methods: {
    chooseGoods(index) {
      this.goodsIndex = index;
      this.goodsInfo = this.goodsList[index];
    },
    handleNodeClick(node) {
      this.getInitVideo(node);
      this.changeVideo();
    },
    changeVideo() {
      let video = this.currentNode;

      let subjectId = this.$route.query.subjectId;
      ///{userId}/{resId}/{subjectId}
      this.$HTTP
        .executeGet(
          `${this.$APIS.GET_TFMJ_PLAY}/${this.user.id}/${video.resId}/${subjectId}`,
          this
        )
        .then(res => {
          if (res.code == 0) {
            if (res.data.length == 0) {
              video.canPlay = true;
              this.dialogVisible = false;
              video.playRecordsCount += 1;
              this.videoKey = video.resId;
            } else {
              video.canPlay = false;
              this.dialogVisible = true;
              this.goodsList = res.data;
              this.goodsInfo = this.goodsList[0];
              this.videoKey = video.resId;
              this.creatOrder();
            }
          }
        });
    },
    // 关闭弹层 重置参数
    closeDialog() {
      this.wxPay = false;
      this.dialogVisible = false;
    },
    balancePayment() {
      this.$HTTP
        .executeGet(`${this.$APIS.PAY_BALANCE}/${this.orderInfo.id}`, this)
        .then(res => {
          // @ts-ignore
          const { data, code, msg } = res;
          if (code == 0) {
            this.changeVideo();
            this.getBalance();
            this.$message.info("支付成功,请点击播放观看!");
          } else {
            this.$message.error("支付失败!");
          }
        });
    },
    wxEnter() {
      this.wxShow = true;
    },
    wxLeave() {
      this.wxShow = false;
    },
    weChatPayment() {
      //在这里请求接口,通过订单获得生成的二维码
      let params = {
        orderNumber: this.orderInfo.orderNo,
        userId: this.user.id
      };

      this.$axios.post("wxpay/create-vip-pre-order", params).then(res => {
        const { data, status } = res;
        if (status === 200) {
          if (data.code === 0) {
            this.payCodeUrl = data.data.code_url;
            this.wxPay = true;
            this.quertOrderStatus();
          } else {
            this.$message.error("获得支付二维码失败,请重试!");
          }
        }
      });
      //  = 'weixin://wxpay/bizpayurl?pr=Khjd4GM00';
      //轮训请求订单的支付状态
    },
    alipayPayment() {
      // 支付宝支付
      //查询是否有订单
      let param = {
        orderNumber: this.orderInfo.orderNo,
        userId: this.user.id
      };
      // 请求支付宝支付接口
      this.$axios.post("alipay/vip/pay", param).then(res => {
        const { data } = res;
        if (data.code === 0) {
          if (data.data.length) {
            this.html = data.data;
            this.$nextTick(() => {
              document.forms[0].submit();
            });
          } else {
            this.$message.error(data.msg);
          }
        }
      });
    },
    openWindows() {
      try {
        // @ts-ignore
        cefJS.sendmsg("balance");
        this.dialogVisible = false;
      } catch (error) {
        console.log(error);
      }
    },
    getBalance() {
      let user = this.user;
      this.$HTTP
        .executeGet(`${this.$APIS.GET_USER_BLANCE}/${user.id}`, this)
        .then(res => {
          const { data, code, msg } = res;
          if (code === 0) {
            this.price = data;
          } else {
            this.$message.error(msg);
          }
        });
    },
    getVideoList() {
      let user = this.user;
      this.$HTTP
        .executeGet(
          `${this.$APIS.GET_TFMJ_VIDEOLIST}/${user.id}/${this.$route.query.subjectId}`,
          this
        )
        .then(res => {
          const { data, code, msg } = res;
          if (code === 0) {
            this.videoList = data;
            this.getInitVideo(data);
          } else {
            this.$message.error(msg);
          }
        });
    },
    /**
     * 获取当前树结构的第一个视频
     */
    getInitVideo(tree) {
      //如果为空直接返回,则无视频
      if (tree == null) {
        this.currentNode = {};
        return;
      }
      //如果当前节点不为空且视频为空,但子为空
      if (!tree.path && !!tree.sources && !tree.sources.length) {
        this.currentNode = tree;
        return;
      }
      //如果path不为空,则证明有视频
      if (tree.path) {
        this.currentNode = tree;
        return;
      }
      //如果当前视频path不为空且选中的node的path为空,则不作改变
      if (!tree.path && !!this.currentNode.path) {
        return;
      }

      //如果节点无视频,但子节点length不为0,子节点赋值,寻找第一个视频
      if (!tree.length && !!tree.sources.length) {
        tree = tree.sources;
      }

      //寻找第一个视频
      for (let i = 0; i < tree.length; i++) {
        let e = tree[i];
        if (e.path) {
          this.currentNode = e;
          return;
        } else {
          if (!!e.sources && e.sources.length != 0) {
            this.getInitVideo(e.sources);
          }
        }
      }
    },
    quertOrderStatus() {
      // 查看订单状态
      this.$axios
        .get(`vip/order/find/${this.orderInfo.id || 2171}`)
        .then(res => {
          const { status, data } = res;
          if (status === 200) {
            if (data.code === 0) {
              if (data.data.status != null && data.data.status == "1") {
                //如果支付成功，则重新刷新这些页面的数据
                this.changeVideo();
                this.closeDialog();
              } else {
                setTimeout(() => {
                  this.quertOrderStatus();
                }, 2000);
              }
            }
          }
        });
    },

    async creatOrder() {
      // 是否登陆的判断
      if (!window.localStorage.getItem("isLogin")) {
        this.$store.commit("changeIsShowLogin", true);
        return false;
      }
      let video = this.currentNode;
      console.log("this.goodsInfo == > ", this.goodsInfo);
      let params = {
        userId: this.user.id,
        tradeGoodsId: this.goodsInfo.tradeGoodsId,
        resId: video.resId,
        subjectId: this.$route.query.subjectId
      };
      // 创建订单
      this.$axios.post("vip/order/add", params).then(resD => {
        const { status, data } = resD;
        if (status === 200) {
          if (data.code === 0) {
            this.orderInfo = data.data;
          }
        }
      });
    }
  },
  created() {
    this.user = this.$store.getters.getUserInfo;
    this.getVideoList();
    this.getBalance();
  },
  mounted() {
    //切换学科，关闭当前窗口
    window.addEventListener("storage", chooseSubjectId => {
      if (chooseSubjectId != this.$route.query.subjectId) {
        window.close();
      }
    });
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-tree-node:focus > .el-tree-node__content {
  background-color: #000;
}
/deep/ .el-tree-node:hover > .el-tree-node__content {
  background-color: #000;
}
</style>
<style lang="less" scoped>
.improve {
  background-color: #000000;
  width: 100%;
  height: 100%;
  .title {
    width: 100%;
    height: 150px;
    font-size: 28px;
    color: #fff;
    text-align: center;
    line-height: 150px;
  }
  .content {
    background-color: #000000;
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 70px;
    .video {
      width: 1083px;
      height: 604px;
    }
    .player-card {
      width: 600px;
      height: 604px;
      color: red;
      background-color: #404040;
      .title {
        height: 50px;
        width: 100%;
        letter-spacing: 0px;
        color: #aaaaaa;
        text-align: left;
        text-indent: 34px;
        line-height: 50px;
        font-size: 28px;
        border-bottom: solid 1px #404040;
      }
     .el-tree{
        /deep/ .el-tree-node{
          padding: 5px 0;
          font-size: 24px;
        }
      }
      .list-content {
        width: 100%;
        height: auto;
        padding: 20px 36px 20px 36px;
        display: flex;
        flex-wrap: wrap;
        .item {
          width: 48px;
          height: 48px;
          color: #ffffff;
          font-size: 21px;
          line-height: 48px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
/deep/ .pay-dialod-visible {
  width: 612px;
  height: 530px;
  background-color: #fff;
  padding: 0;
  .count {
    .wx_box_success {
      h3 {
        font-size: 30px;
        color: #585858;
        text-align: center;
      }
    }
    .wx_box {
      background-color: #fff;
      margin-top: 15px;
      h3 {
        font-size: 18px;
        color: #585858;
        text-align: center;
      }

      .price {
        text-align: center;
        font-size: 18px;
        color: #585858;
        margin-top: 20px;

        .p_num {
          font-size: 28px;
          text-decoration: line-through;
        }

        .p_num_new {
          font-size: 28px;
          color: #e50001;
        }
      }
    }
    .zfb_box {
      background-color: #fff;
      margin-top: 20px;
      .goodsList {
        height: 100px;
        width: 100%;
        display: inline-flex;
        justify-content: space-around;
        padding: 20px 35px 20px 20px;
        .goodsItem {
          width: 140px;
          height: 59px;
          background-color: #ffffff;
          border-radius: 10px;
          border: solid 1px #db0000;
          text-align: center;
          line-height: 59px;
          font-size: 24px;
          color: #ff0000;
          cursor: pointer;
        }
        .active {
          background-color: #ff0000;
          color: #fff;
        }
      }
      h3 {
        font-size: 18px;
        color: #585858;
        text-align: center;
      }
      .foot-vip {
        .text-info {
          font-size: 16px;
          text-align: center;
        }
        .btn-container {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-bottom: 20px;
          /deep/ .el-button {
            background: #1890ff;
            color: #fff;
            margin-top: 20px;
          }

          .el-button {
            background: #1890ff;
            color: #fff;
          }
        }
      }
    }
    width: 100%;
    height: 100%;
    position: relative;
    .has_active_price {
      font-size: 28px;
      color: red;
      line-height: 58px;
      margin-left: 38px;
      width: 200px;

      .lineation {
        font-size: 16px;
        color: #a6a6a6;
      }

      .vipPreferential {
        display: block;
      }
    }
    .vip_card {
      width: 290px;
      float: right;
      height: auto;
      margin-right: 10px;
      margin-top: 10px;
      cursor: pointer;
    }
    .right_c {
      width: 100%;
      height: 300px;
      float: right;
      background-color: #fff;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .wx {
        width: 190px;
        float: left;
        height: 60px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        cursor: pointer;
      }

      .wx:hover {
        box-shadow: 10px 10px 10px #ddd;
      }

      .zfb {
        width: 190px;
        height: 60px;
        float: right;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .zfb:hover {
        box-shadow: 10px 10px 10px #ddd;
      }
    }
    .right {
      .right_QrCode {
        width: 200px;
        margin: 10px auto;
        .right_QrCode_img {
          width: 200px !important;
          height: 200px !important;
        }
        img {
          width: 200px !important;
          height: 200px !important;
        }
      }
      .imageOne {
        width: 100%;
      }
    }

    .pOne {
      width: 100%;
      color: #575757;
      margin-top: 10px;
      font-size: 16px;
      float: right;
      text-align: center;

      .pay_r {
        float: right;
        cursor: pointer;
      }
    }
  }
}

/deep/ .paper-type-dialod-visible {
  width: 570px;
  height: auto;
  .el-dialog__header {
    padding: 0;
    height: 79px;
    background: #5c307d;
    line-height: 79px;
    .el-dialog__title {
      color: #fff;
    }
    .el-dialog__headerbtn {
      .el-dialog__close {
        color: #fff;
        font-size: 24px;
      }
    }
  }
  .el-dialog__body {
    ul {
      li {
        height: 68px;
        line-height: 68px;
        border-bottom: 1px dashed #afafaf;
        margin-top: 20px;
        font-size: 20px;
        color: #3c3c3c;

        .selest {
          width: 48px;
          height: 48px;
          float: right;
          margin-top: 10px;
          cursor: pointer;
        }
      }
    }
    button {
      width: 120px;
      height: 42px;
      background: #5c307d;
      color: #fff;
      border: none;
      border-radius: 4px;
      margin-top: 20px;
      margin-left: 38%;
      cursor: pointer;
    }
  }
}

/deep/ .has_active {
  .new_user {
    margin-left: 38px;
    border: 1px solid #ff6672;
    background: #ffdede;
    display: inline-block;
    border-radius: 6px;
    padding: 7px 14px;
    font-size: 16px;
  }

  .new_user_name {
    margin-left: 38px;
    margin-top: 14px;
    font-size: 16px;
    color: #a6a6a6;
  }
  .pay_type {
    margin-top: 53px;
    margin-left: 38px;
    font-size: 20px;
    color: #585858;
  }
  .has_active_price {
    font-size: 28px;
    color: red;
    line-height: 58px;
    margin-left: 38px;
    width: 200px;

    .lineation {
      font-size: 16px;
    }
  }

  .vip_card {
    width: 290px;
    float: right;
    height: auto;
    margin-right: 10px;
    margin-top: 10px;
    cursor: pointer;
  }
  .tips_d {
    margin-left: 38px;
    margin-top: 14px;
    font-size: 16px;
    color: #a6a6a6;
  }

  .right_d {
    width: 100%;
    float: right;
    background-color: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-bottom: 20px;

    .wx {
      margin-top: 26px;
      padding: 6px 18px;
      width: 190px;
      float: left;
      height: 60px;
      position: relative;
      border-radius: 6px;
      background-color: #fff;
      border: 1px solid #a6a6a6;
      img {
        width: 100%;
        height: 100%;
      }
      cursor: pointer;
    }

    .wx:hover {
      box-shadow: 10px 10px 10px #ddd;
    }

    .zfb {
      margin-top: 26px;
      padding: 6px 18px;
      border-radius: 6px;
      width: 190px;
      height: 60px;
      float: right;
      cursor: pointer;
      border: 1px solid #a6a6a6;
      background-color: #fff;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .zfb:hover {
      box-shadow: 10px 10px 10px #ddd;
    }
  }
}
.pay_types {
  margin-top: 15px;
  margin-left: 38px;
  font-size: 20px;
  color: #585858;
  text-align: left;
}
.right_f {
  width: 100%;
  float: right;
  background-color: #fff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;

  .wx {
    margin-top: 26px;
    padding: 6px 18px;
    width: 190px;
    float: left;
    height: 60px;
    position: relative;
    border-radius: 6px;
    background-color: #fff;
    border: 1px solid #a6a6a6;
    img {
      width: 100%;
      height: 100%;
    }
    cursor: pointer;
  }

  .wx:hover {
    box-shadow: 10px 10px 10px #ddd;
  }

  .zfb {
    margin-top: 26px;
    padding: 6px 18px;
    border-radius: 6px;
    width: 190px;
    height: 60px;
    float: right;
    cursor: pointer;
    border: 1px solid #a6a6a6;
    background-color: #fff;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .zfb:hover {
    box-shadow: 10px 10px 10px #ddd;
  }

  .balance {
    margin-top: 26px;
    border-radius: 6px;
    width: 480px;
    height: 60px;
    cursor: pointer;
    border: 1px solid #a6a6a6;
    background-color: #fff;
    .left {
      float: left;
      width: 330px;
      margin-left: 18px;
      img {
        width: 47px;
        float: left;
        margin-top: 9px;
        margin-right: 10px;
      }
      .msg {
        float: left;
        line-height: 60px;
        font-size: 18px;
      }
    }
    .right {
      float: right;
      width: 88px;
      height: 58px;
      color: #fff;
      background: #5c307d;
      border-radius: 4px;
      border: none;
      outline: none;
      font-size: 18px;
      cursor: pointer;
    }
  }
  .balance:hover {
    box-shadow: 10px 10px 10px #ddd;
  }
}

.main-list-left {
  width: 310px;
  // position: absolute;
  position: fixed;
  top: 144px;
  bottom: 63px;
  left: 190px;
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
  z-index: 2;

  .list_bottom {
    position: absolute;
    top: 75px;
    bottom: 20px;
    left: 0;
    right: 0;
    overflow-y: auto;
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-color: transparent transparent;
    scrollbar-track-color: transparent;
    -ms-scrollbar-track-color: transparent;
    --scrollbar-width: thin; /* or `auto` or `none` */
  }

  .list_bottom::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 4px;
    height: 6px;
  }
  .list_bottom::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background-color: rgba(0, 0, 0, 0.2);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }

  .tabs {
    width: 300px;
    height: 50px;
    padding-top: 1px;
    margin-top: 25px;
    border-bottom: 1px solid #aaaaaa;
    font-size: 20px;
    color: #aaaaaa;
    .paper-title {
      margin-left: 18px;
    }

    .tab-left {
      width: 134px;
      height: 48px;
      border: 1px solid #aaaaaa;
      float: left;
      margin-right: 10px;
      text-align: center;
      line-height: 48px;
      border-bottom: none;
      color: #585858;

      .top {
        margin-left: 10px;
        width: 13px;
        height: 17px;
        vertical-align: -1px;
      }
    }

    .tab-left:hover {
      color: #fff;
      background-color: #5c307d;
      border-color: #5c307d;
      cursor: pointer;
    }

    .tab-active {
      color: #fff;
      background-color: #5c307d;
      border-color: #5c307d;
      cursor: pointer;
    }

    .tab-right {
      cursor: pointer;
      margin-right: 22px;
      margin-top: 15px;
      float: right;
      width: 19px;
      height: 19px;
    }
  }

  .tabel {
    width: 100%;
    height: auto;
    margin-top: 15px;

    li {
      width: 100%;
      color: #5a5a5a;
      font-size: 20px;
      cursor: pointer;
      list-style: none;
      position: relative;
      padding: 5px 0;

      .p-name {
        line-height: 30px;
        padding-left: 20px;
        padding-right: 20px;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      span {
        display: block;
        min-width: 22px;
        height: 22px;
        border-radius: 11px;
        border: 1px solid #ff9f9f;
        font-size: 12px;
        position: absolute;
        text-align: center;
        line-height: 22px;
        color: #f00000;
        background-color: #ffdfdf;
        left: 24px;
        top: 8px;
      }

      .free {
        border: 1px solid #07d237;
        background-color: #ceffe4;
        color: #45db64;
      }
    }
    li:hover {
      color: #0a1522;
    }
    .active {
      color: #0072ff;
    }
  }
}

.main-detail-right {
  width: 80%;
  height: 100%;
  // padding-left: 310px;
  position: relative;
  margin: 0 auto;
  .detail-right-box {
    position: absolute;
    bottom: 20px;
    top: 0px;
    // bottom:20px;
    right: 0;
    // left: 320px;
    width: 100%;
    background-color: #fff;
  }
  .condition {
    position: fixed;
    top: 72px;
    left: 0;
    right: 0;
    height: 72px;
    background-color: #f5f5f5;
    li {
      height: 72px;
      font-size: 20px;
      display: flex;
      margin: 0 auto;
      width: 1000px;

      .left {
        width: 78px;
        line-height: 72px;
        margin-left: 100px;
        color: #aaaaaa;
      }

      .right {
        flex: 1;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        cursor: pointer;

        .span {
          width: 90px;
          height: 36px;
          text-align: center;
          line-height: 36px;
          border-radius: 18px;
          float: left;
          margin-right: 25px;
          color: #585858;
          margin-top: 18px;
          cursor: pointer;
        }

        .span:hover {
          color: #0072ff;
          background: #fff;
        }

        .active {
          color: #0072ff;
          background: #fff;
        }
      }
    }

    .li-bottom {
      border-bottom: 1px solid #aaaaaa;
    }
  }

  .center {
    width: 100%;
    height: 266px;
    margin: 0 auto;
    margin-top: 72px;

    .left {
      float: left;
      width: 380px;
      height: 246px;
      margin-top: 20px;
      margin-left: 32px;
    }

    .right {
      width: 730px;
      float: left;
      margin-top: 20px;
      margin-left: 36px;

      .title {
        font-size: 28px;
        color: #565656;
        line-height: 52px;
        height: 104px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-bottom: 12px;
      }

      .m-r {
        margin-right: 75px;
      }

      .m-r-b {
        margin-right: 64px;
      }

      .p-time {
        font-size: 18px;
        line-height: 33px;
        color: #a3a3a3;

        .text {
          color: #575757;
        }
      }

      .price {
        width: 100%;
        margin-top: 40px;
        .time-limit {
          display: inline-flex;
          font-size: 14px;
          .left-text {
            font-size: 32px;
            color: #fffc00;
            height: 55px;
            width: 180px;
            text-align: center;
            line-height: 55px;
            background-image: linear-gradient(to right, #fc9c21, #f4152a);
          }
          .right-text {
            background-color: #5c307d;
            height: 55px;
            width: 240px;
            display: inline-flex;
            line-height: 55px;
            .first {
              font-size: 18px;
              color: #fffc00;
              line-height: 63px;
              margin-left: 30px;
            }
            .second {
              font-size: 18px;
              color: red;
              text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white;
              .price {
                font-size: 32px;
              }
            }
            .original {
              margin-left: 20px;
              line-height: 63px;
              font-size: 18px;
              color: #fffc00;
              text-decoration: line-through;
            }
          }
        }
        .button-right {
          width: 148px;
          height: 43px;
          border-radius: 22px;
          background-color: #5c307d;
          color: #ffffff;
          border: none;
          cursor: pointer;
          font-size: 21px;
          float: right;
          margin-top: 10px;
          margin-right: 40px;
        }
      }
    }
  }

  .introduce {
    width: 100%;
    padding: 0 20px;
    margin-top: 33px;
    background: #ffffff;
    border-radius: 12px;
    margin-bottom: 50px;

    .pic {
      width: 100%;
    }

    &-tab {
      padding-top: 22px;
      width: 100%;
      font-size: 21px;

      ul {
        height: 44px;
        border-bottom: 1px solid #c7c7c7;
        width: 100%;

        li {
          float: left;
          width: 100px;
          text-align: center;
          margin-left: 45px;
          line-height: 40px;
          color: #5a5a5a;
        }

        li:hover {
          border-bottom: 4px solid #5c307d;
          box-sizing: border-box;
          cursor: pointer;
        }

        .active {
          border-bottom: 4px solid #5c307d;
          box-sizing: border-box;
        }

        .first-li {
          width: 200px;
        }
      }
    }
  }
}

.handle {
  height: 44px;
  line-height: 44px;
  text-align: right;
  font-size: 18px;
  color: #5c307d;
  cursor: pointer;

  .top {
    margin: 3px 12px;
  }

  .bottom {
    margin: 0px 12px;
  }
}

.no-content {
  margin-top: 80px;

  p {
    color: #585858;
    font-size: 16px;
    text-align: center;
  }
}
.tabel-fk {
  width: 100%;
  height: auto;
  padding: 3px;

  li {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 9px;
    cursor: pointer;
    position: relative;

    .p-img {
      width: 270px;
      height: 175px;
      display: block;
      margin-left: 15px;
      padding-top: 15px;
      /* position: relative; */
      img {
        width: 100%;
        height: 100%;
        display: block;
        /*width: 270px;
          height: 175px;
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          transition: width 0.3s, height 0.3s, left 0.3s, top 0.3s; */
      }
      /* img:hover {
          left: -6px;
          top: -6px;
          width: 284px;
          height: 185px;
        } */

      /* .active {
          left: -6px;
          top: -6px;
          width: 284px;
          height: 185px;
        } */
    }

    .p-name {
      margin: 10px auto 10px 15px;
      line-height: 33px;
      color: #585858;
      width: 270px;
      font-size: 18px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .label {
      position: absolute;
      top: 8px;
      right: 10px;
      width: 80px;
      height: 80px;

      img {
        width: 100%;
        height: 100%;
      }
      span {
        display: block;
        transform: rotate(45deg);
        color: #fff;
        font-size: 14px;
        position: absolute;
        top: 0;
        left: 0;
        width: 80px;
        height: 80px;
        line-height: 50px;
        text-align: center;
      }
    }
  }
  li:hover {
    box-shadow: 0 3px 9px 0 #595959;
  }
  .active {
    box-shadow: 0 3px 9px 0 #595959;
  }
}
</style>